import fileDownload from "js-file-download";

class DownloadUtil {
    static zip(data: any, name: string): void {
        fileDownload(
            data,
            name + ".zip",
            "application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip"
        );
    }

    static xlsx(data: any, name: string): void {
        fileDownload(
            data,
            name + ".xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
    }

    static csv(data: any, name: string): void {
        fileDownload(
            data,
            name + ".csv",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
    }
}

export { DownloadUtil }